var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"graphic-content"},[_c('div',{staticClass:"graphic-banner-image",style:({ backgroundImage: `url(${_vm.graphicBannerImageSrc})` })}),_c('div',{staticClass:"graphic-overlay-image"},[_c('h1',{staticClass:"graphic-banner-title"},[_vm._v(_vm._s(_vm.graphicBannerImageTitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }